import React, {Component} from 'react';
import Select from 'react-select';
import Search from 'material-ui/svg-icons/action/search'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
//css
import './Search-bar.css'
import '../../framework/Nav/home_nav.css';
import {filter, findIndex, isEmpty, remove, sortBy} from "lodash";
/**
 * @property handleSearch {funciton} the seach button be clicked callback
 * @property placeholder {string}
 */
class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionsArr: [],
      selectedItemLabel: '', // selected label string.
      disabledAllClientsOption : true,
    }
  }
  componentWillReceiveProps (nextProps) {
    if (this.props.clients !== nextProps.clients){
      this.initializeClientList(this.state.disabledAllClientsOption, nextProps.clients)
    }
  }
  componentDidMount(){
    if (this.props.clients)
      this.initializeClientList(this.state.disabledAllClientsOption, this.props.clients)
  }
  initializeClientList(disabledAllClientsOption, clients){
    disabledAllClientsOption = true
    let clientsList =  []
    if (clients){
      const sortedClients = sortBy(clients, function(c){
        return c.name.toLowerCase()
      })

      if ((clients.length === 1) && (clients[0].id <= 1)){
        clientsList = remove(clientsList, function(c){
          return c.id !== 0
        })
      }
      sortedClients.forEach(function(item){
        if (item.id > 1){
          clientsList.push({id: item.id, name: item.name})
          if (!isEmpty(item.businessUnits)){
            const sortedSubClients = sortBy(item.businessUnits, function(c){
              return c.name.toLowerCase()
            })
            sortedSubClients.forEach(function(sc){
              clientsList.push({id: sc.id, name: '      ' + sc.name})
            })
          }
          //}
        }
      })
    }
    this.setState({
      optionsArr:clientsList,
      clientAdminMode: this.props.roleId > 1 && this.props.roleId < 10,
      businessUserMode: this.props.roleId > 50,
      businessAdminMode: this.props.roleId === 51
    })
    if (((disabledAllClientsOption === true) &&
      (parseInt(this.props.selected_client, 10) === 0) && (clientsList.length > 1)) ||
      (this.props.roleId > 50 && parseInt(this.props.selected_client, 10) === 0))  {
      if (clientsList.length > 1){
        this.setState({optionVal: clientsList[1].id})
        this.props.selectClient(clientsList[1].id)
      }
    }
  }
  handleSearch () {
    this.props.handleSearch(this.state.selectedItemLabel);
  }
  handleOnChange (selectedItem) {
    if (selectedItem === null) {
      this.setState({
        selectedItemLabel: ''
      })
    } else {
      this.setState({
        selectedItemLabel: selectedItem.value
      })
    }
  }
  optionRenderer(option){
    return (<span>{option.label}</span>)
  }
  filterOption(option, filterString){
    if (isEmpty(filterString))
      return option
    //if ((option.value === '0') || (option.value.indexOf('r-') >= 0))
    //  return option
    if (option.label.toLowerCase().indexOf(filterString.toLowerCase()) >= 0)
      return option

    const {clients} = this.props
    const sltClients = filter(clients, function(c){
      return (c.name.toLowerCase().indexOf(filterString) >= 0) && (!isEmpty(c.businessUnits))
    })
    let hit = false
    sltClients.forEach(function(c){
      if (findIndex(c.businessUnits, function(item){return item.id.toString() === option.value}) >= 0){
        hit = true
        return
      }
    })
    if (hit) return option
  }
  render () {
    const clientOptions = []
    this.state.optionsArr.forEach((item, index) => {
      clientOptions.push({value: item.id.toString(), label: item.name})
    })
    return (
      <MuiThemeProvider>
        <div className="subscription-typeahead clearfix">
          <span className="s">Search</span>
          <div className="type-ahead-container">
            <Select
              name=""
              placeholder={this.props.placeholder}
              value={this.state.selectedItemLabel}
              clearable={false}
              options={clientOptions}
              optionRenderer={(val) => this.optionRenderer(val)}
              onChange={(val) => this.handleOnChange(val)}
              filterOption={this.filterOption.bind(this)}
            />
          </div>
          <button onClick={() => this.handleSearch()} style={{cursor:'pointer'}}>
            <Search
              style={{color: 'white'}}
            />
          </button>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default SearchBar;



// WEBPACK FOOTER //
// ./src/components/SubscriptionsInfo/SearchBar/SearchBar.jsx